export default function checkHtmlDialogElement() {
  return typeof HTMLDialogElement === 'function' ? true : false;
}
